/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  GetAccount200Response,
  GetAccountMembership200Response,
  GetAccountMembershipCampsites200Response,
  GetAccountMembershipContactEmails200Response,
  GetAccountMembershipContactPhones200Response,
  GetAccountMembershipPayments200Response,
  GetAccountMembershipRelatives200Response,
  ListAccounts200Response,
  ListAccountsOrderParameterInner,
  ListLinkedMemberRelatives200Response,
  ListLinkedMembers200Response,
  ReplaceAccountRequest,
  UpdateAccountRequest,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    GetAccount200ResponseFromJSON,
    GetAccount200ResponseToJSON,
    GetAccountMembership200ResponseFromJSON,
    GetAccountMembership200ResponseToJSON,
    GetAccountMembershipCampsites200ResponseFromJSON,
    GetAccountMembershipCampsites200ResponseToJSON,
    GetAccountMembershipContactEmails200ResponseFromJSON,
    GetAccountMembershipContactEmails200ResponseToJSON,
    GetAccountMembershipContactPhones200ResponseFromJSON,
    GetAccountMembershipContactPhones200ResponseToJSON,
    GetAccountMembershipPayments200ResponseFromJSON,
    GetAccountMembershipPayments200ResponseToJSON,
    GetAccountMembershipRelatives200ResponseFromJSON,
    GetAccountMembershipRelatives200ResponseToJSON,
    ListAccounts200ResponseFromJSON,
    ListAccounts200ResponseToJSON,
    ListAccountsOrderParameterInnerFromJSON,
    ListAccountsOrderParameterInnerToJSON,
    ListLinkedMemberRelatives200ResponseFromJSON,
    ListLinkedMemberRelatives200ResponseToJSON,
    ListLinkedMembers200ResponseFromJSON,
    ListLinkedMembers200ResponseToJSON,
    ReplaceAccountRequestFromJSON,
    ReplaceAccountRequestToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
} from '../models/index';

export interface DisableAccountRequest {
    accountID: string;
}

export interface EnableAccountRequest {
    accountID: string;
}

export interface GetAccountRequest {
    accountID: string;
}

export interface GetAccountMembershipRequest {
    accountID: string;
}

export interface GetAccountMembershipCampsitesRequest {
    accountID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GetAccountMembershipContactEmailsRequest {
    accountID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GetAccountMembershipContactPhonesRequest {
    accountID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GetAccountMembershipPaymentsRequest {
    accountID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GetAccountMembershipRelativesRequest {
    accountID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GrantAdminToAccountRequest {
    accountID: string;
}

export interface ListAccountsRequest {
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListLinkedMemberRelativesRequest {
    accountID: string;
}

export interface ListLinkedMembersRequest {
    accountID: string;
}

export interface ReplaceAccountOperationRequest {
    accountID: string;
    replaceAccountRequest: ReplaceAccountRequest;
}

export interface RevokeAdminFromAccountRequest {
    accountID: string;
}

export interface UpdateAccountOperationRequest {
    accountID: string;
    updateAccountRequest: UpdateAccountRequest;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * Disable account
     * Disable Account
     */
    async disableAccountRaw(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling disableAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/disable`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Disable account
     * Disable Account
     */
    async disableAccount(requestParameters: DisableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.disableAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable account
     * Enable Account
     */
    async enableAccountRaw(requestParameters: EnableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling enableAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/enable`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Enable account
     * Enable Account
     */
    async enableAccount(requestParameters: EnableAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.enableAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account
     * Get Account
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account
     * Get Account
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership
     * Get Account Membership
     */
    async getAccountMembershipRaw(requestParameters: GetAccountMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembership200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembership().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembership200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership
     * Get Account Membership
     */
    async getAccountMembership(requestParameters: GetAccountMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembership200Response> {
        const response = await this.getAccountMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership campsites
     * Get Account Membership Campsites
     */
    async getAccountMembershipCampsitesRaw(requestParameters: GetAccountMembershipCampsitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipCampsites200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembershipCampsites().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership-campsites`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipCampsites200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership campsites
     * Get Account Membership Campsites
     */
    async getAccountMembershipCampsites(requestParameters: GetAccountMembershipCampsitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipCampsites200Response> {
        const response = await this.getAccountMembershipCampsitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership contact emails
     * Get Account Membership Contact Emails
     */
    async getAccountMembershipContactEmailsRaw(requestParameters: GetAccountMembershipContactEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipContactEmails200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembershipContactEmails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership-contact-emails`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipContactEmails200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership contact emails
     * Get Account Membership Contact Emails
     */
    async getAccountMembershipContactEmails(requestParameters: GetAccountMembershipContactEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipContactEmails200Response> {
        const response = await this.getAccountMembershipContactEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership contact phones
     * Get Account Membership Contact Phones
     */
    async getAccountMembershipContactPhonesRaw(requestParameters: GetAccountMembershipContactPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipContactPhones200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembershipContactPhones().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership-contact-phones`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipContactPhones200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership contact phones
     * Get Account Membership Contact Phones
     */
    async getAccountMembershipContactPhones(requestParameters: GetAccountMembershipContactPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipContactPhones200Response> {
        const response = await this.getAccountMembershipContactPhonesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership payments
     * Get Account Membership Payments
     */
    async getAccountMembershipPaymentsRaw(requestParameters: GetAccountMembershipPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipPayments200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembershipPayments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership-payments`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipPayments200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership payments
     * Get Account Membership Payments
     */
    async getAccountMembershipPayments(requestParameters: GetAccountMembershipPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipPayments200Response> {
        const response = await this.getAccountMembershipPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get account membership relatives
     * Get Account Membership Relatives
     */
    async getAccountMembershipRelativesRaw(requestParameters: GetAccountMembershipRelativesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipRelatives200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling getAccountMembershipRelatives().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/membership-relatives`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipRelatives200ResponseFromJSON(jsonValue));
    }

    /**
     * Get account membership relatives
     * Get Account Membership Relatives
     */
    async getAccountMembershipRelatives(requestParameters: GetAccountMembershipRelativesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipRelatives200Response> {
        const response = await this.getAccountMembershipRelativesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grant admin
     * Grant Admin
     */
    async grantAdminToAccountRaw(requestParameters: GrantAdminToAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling grantAdminToAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/grant-admin`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Grant admin
     * Grant Admin
     */
    async grantAdminToAccount(requestParameters: GrantAdminToAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.grantAdminToAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List accounts
     * List Accounts
     */
    async listAccountsRaw(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccounts200Response>> {
        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccounts200ResponseFromJSON(jsonValue));
    }

    /**
     * List accounts
     * List Accounts
     */
    async listAccounts(requestParameters: ListAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccounts200Response> {
        const response = await this.listAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List linked member relatives
     * List Linked Member Relatives
     */
    async listLinkedMemberRelativesRaw(requestParameters: ListLinkedMemberRelativesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListLinkedMemberRelatives200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling listLinkedMemberRelatives().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/linked-member-relatives`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListLinkedMemberRelatives200ResponseFromJSON(jsonValue));
    }

    /**
     * List linked member relatives
     * List Linked Member Relatives
     */
    async listLinkedMemberRelatives(requestParameters: ListLinkedMemberRelativesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListLinkedMemberRelatives200Response> {
        const response = await this.listLinkedMemberRelativesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List linked members
     * List Linked Members
     */
    async listLinkedMembersRaw(requestParameters: ListLinkedMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListLinkedMembers200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling listLinkedMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/linked-members`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListLinkedMembers200ResponseFromJSON(jsonValue));
    }

    /**
     * List linked members
     * List Linked Members
     */
    async listLinkedMembers(requestParameters: ListLinkedMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListLinkedMembers200Response> {
        const response = await this.listLinkedMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace account
     * Replace Account
     */
    async replaceAccountRaw(requestParameters: ReplaceAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling replaceAccount().'
            );
        }

        if (requestParameters['replaceAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceAccountRequest',
                'Required parameter "replaceAccountRequest" was null or undefined when calling replaceAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceAccountRequestToJSON(requestParameters['replaceAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Replace account
     * Replace Account
     */
    async replaceAccount(requestParameters: ReplaceAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.replaceAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke admin
     * Revoke Admin
     */
    async revokeAdminFromAccountRaw(requestParameters: RevokeAdminFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling revokeAdminFromAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}/revoke-admin`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Revoke admin
     * Revoke Admin
     */
    async revokeAdminFromAccount(requestParameters: RevokeAdminFromAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.revokeAdminFromAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update account
     * Update Account
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAccountRequest',
                'Required parameter "updateAccountRequest" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/accounts/{accountID}`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters['updateAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Update account
     * Update Account
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccount200Response> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
